import { getAppHost } from 'helpers'
import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'

// Generic function to submit dynamic forms
export const submitDynamicForm = async (app, appSettings, endpoint, method, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/${endpoint}`

    const config = {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    }

    let response
    switch (method.toUpperCase()) {
      case 'POST':
        response = await axios.post(baseURL, payload, config)
        break
      case 'PUT':
        response = await axios.put(baseURL, payload, config)
        break
      case 'PATCH':
        response = await axios.patch(baseURL, payload, config)
        break
      case 'DELETE':
        response = await axios.delete(baseURL, config)
        break
      case 'GET':
      default:
        response = await axios.get(baseURL, config)
        break
    }

    return response.data
  } catch (error) {
    throw error
  }
}

// Generic function to fetch dynamic data (for form options, etc.)
export const fetchDynamicData = async (app, appSettings, endpoint) => {
  try {
    const apiHost = getAppHost(appSettings)
    const baseURL = `${getChatApiBase(app, apiHost)}/${endpoint}`

    const response = await axios.get(baseURL, {
      headers: { ...getChatApiHeaders(app), chatapiversion: 'v3.0' },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
